(function($, undefined) {

	/**
	 * Inicializace Google Places Autocomplete po AJAXu
	 */
	$.nette.ext('googlePlacesAutocomplete', {
		success: function () {
			if (typeof pdGmap !== 'undefined' && 'initializeAutocomplete' in pdGmap) {
				pdGmap.initializeAutocomplete();
			}
		}
	});

})(jQuery);
